<ngx-spinner bdColor="rgba(40, 40, 40, 0.7)" size="medium" color="#fff" type="ball-clip-rotate-multiple"></ngx-spinner>
<div class="class-body">
    <div class="container-full">
        <router-outlet></router-outlet>
    </div>
</div>